<template>
  <div>
    <v-dialog v-model="$store.state.isProfileVisible" width="1024">
      <template v-slot:activator="{ props }">
        <v-list-item
          link
          v-bind="props"
          @click="$store.dispatch('fetchProfileInfo')"
        >
          <v-list-item-title class="link-list"> Profile </v-list-item-title>
        </v-list-item>
      </template>

      <v-card v-if="profileInfo.userName" class="pa-4">


        <v-card-title class="d-flex  mx-4">
          <span class="font-weight-bold text-1">Profile</span>
          <v-spacer> </v-spacer>
          <v-icon @click="$store.commit('profileVisible', false)" icon="mdi-close" justify="end"></v-icon>
        </v-card-title>


     
        <div class="d-flex justify-center my-4">
          <qrcode-vue
            v-if="profileInfo.organization"
            :value="qrData"
            :size="180"
            :level="'M'"
          />
        </div>
        <profile-fields />


        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            class="ma-0 mx-6 mt-4"
            color="error"
            variant="elevated"
            @click="delOption = !delOption"
            >Delete Profile
          </v-btn>
        </v-card-actions>

        <!-- Actions -->
        <div>
          <v-dialog v-model="delOption" width="256" class="text-wrap text-center ">
            <v-card class="pa-4">
              <p>
                <span>Are you sure you want to delete your profile?</span>
              </p>
              <v-card-actions class="mt-4">
                <v-spacer></v-spacer>
                <v-btn
                  class="ma-0 mr-2"
                  color="domain-button-color"
                  variant="elevated"
                  @click="delOption = false"
                >
                  No
                </v-btn>

                <v-btn
                  class="ma-0 mr-2"
                  color="error"
                  variant="elevated"
                  @click="delProfile"
                >
                  Yes
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>

              <!-- FINAL NOTIFICATION -->
              <div class="text-center">
                <v-dialog persistent v-model="delResult" width="256" class="text-wrap text-center ">
                  <v-card class="pa-4">
                    <v-card-title>{{deleteMsg.title}}</v-card-title>
                    <p>
                      {{deleteMsg.content}}
                    </p>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        class="ma-0 mr-2"
                        color="primary"
                        variant="elevated"
                        @click="delOrBack"
                      >
                        OK
                      </v-btn>
                      <v-spacer></v-spacer>

                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>


            </v-card>
          </v-dialog>
      
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  AnalyticsEvents,
  recordAnalyticsEvent,
} from "@/services/awsPinpointAnalyticsService";
import ProfileFields from './ProfileFields.vue';
import QrcodeVue from 'qrcode.vue';
export default {
  data() {
    return {
      delOption: false,
      delResult: false,
    };
  },
  methods: {
    delOrBack(){
      console.log("del Statement" , this.deleteMsg);
      if(this.deleteMsg.delOrBack == false){
        this.delOption = false;
        return this.delResult=false;
      }
      else{
        return (
          this.$store.dispatch("logout")
            .then(() => {
              this.$router.push("/");
              this.$store.commit("updateUserLoggedIn");
            })
        )
      }
    },
    delProfile() {
      recordAnalyticsEvent(AnalyticsEvents.v2Signout);
      this.$store.dispatch("deleteProfile")
        .then( () => this.delResult= true )
    },
  },
  components:{
    ProfileFields,
    QrcodeVue
  },
  computed: {
    ...mapState(["profileInfo", "deleteProfileError"]),
    qrData() {
      if (!this.profileInfo.organization) return '';
      const org = this.profileInfo.organization;
      console.log('Profile Info:', this.profileInfo)
      return JSON.stringify({
        rollNumber: org.rollNumber,
        batch: org.batch,
        course: org.course,
        center: org.center,
        email: org.email,
        name: org.name,
      });
    },
    deleteMsg: {
      get(){
        let msg= {};
        if(this.deleteProfileError !== ""){
          msg = {
            title: "Profile Not Deleted!",
            content: this.deleteProfileError.error,
            delOrBack: false,
          }
        }
        else{
          msg= {
            title: "Profile Deleted!",
            content: "Your Profile is deleted, the app will reload now!",
            delOrBack: true,
          }
        }
        return msg;
      }
    }
  },
};
</script>

<style scoped>
</style>